import { FieldInfo } from "@alch/ui";
import { useController } from "react-hook-form";

import { SimpleToggleGroup } from "../../../components/ui/index.js";
import ComposerParamLabel from "./ComposerParamLabel.js";
import type { ComposerParamComponentProps } from "./index.js";

const ComposerNullParam = ({
  control,
  name,
  param,
}: ComposerParamComponentProps<"null">) => {
  const { field, fieldState } = useController({ control, name });

  return (
    <div>
      <ComposerParamLabel param={param} />

      <SimpleToggleGroup
        className="mt-2"
        type="single"
        value={String(field.value)}
        onValueChange={(value) =>
          field.onChange(value === "null" ? null : undefined)
        }
        items={[{ label: "null", value: "null" }]}
      />

      <FieldInfo
        errorMessage={fieldState.error?.message}
        description={undefined}
      />
    </div>
  );
};

export default ComposerNullParam;
